import {Alert, Button, Space, Tabs} from "antd";
import {PastCallsComponent} from "../../../components/calls/past-calls";
import {UpcomingCallsComponent} from "../../../components/calls/upcoming-calls";
import {
  StyledPageHeaderWrapper,
  StyledUpcomingCallsWrapper,
} from "../../../components/calls/upcoming-calls/upcoming-calls.style";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {StyledPageHeader, StyledPageWrapper} from "../../../styles/dashboard/calls/calls";
import {AnalyticsEvent} from "../../../utils/analytics";
import {TourWidget} from "../../../components/widgets/tour-widget";
import {NewAvailabilityWidget} from "../../../components/widgets/availability-widget";
import {VideoCameraOutlined} from "@ant-design/icons";
import {CallCategoryModal} from "../../../components/calls/upcoming-calls/call-category-modal";
import {useState} from "react";
import {CanvaTemplateWidget} from "../../../components/widgets/canva-template-widget";
import {ErrorBoundary} from "react-error-boundary";
import {useGetCoachUpcomingCallsContext} from "../../../context/upcoming-calls/coach";

const CallsPage = () => {
  const pageTitle = "1:1 Sessions";
  const [openCallCategoryModal, setOpenCallCategoryModal] = useState<boolean>(false);
  const {
    state: {refetchCoachUpcomingCalls},
  } = useGetCoachUpcomingCallsContext();

  const handleTabClick = (key: string) => {
    if (key === "1") AnalyticsEvent("Coach calls", `Clicked on services tab`);
    if (key === "2") {
      refetchCoachUpcomingCalls();
      AnalyticsEvent("Coach calls", `Clicked on Upcoming calls tab`);
    }
    if (key === "3") AnalyticsEvent("Coach calls", `Clicked on Past calls tab`);
  };

  const handleOk = () => {
    AnalyticsEvent("Service Option Modal", `Selected a service option`);
    setOpenCallCategoryModal(false);
  };
  const handleCancel = () => {
    AnalyticsEvent("Service Option Modal", `Closed service option modal`);
    setOpenCallCategoryModal(false);
  };
  const showCallCategoryModal = () => {
    setOpenCallCategoryModal(true);
  };
  const handleNewServiceBtnClick = () => {
    AnalyticsEvent("Coach calls", `Clicked on Add new service button`);
    showCallCategoryModal();
  };
  return (
    <DashboardWrapper pageTitle={pageTitle}>
      <StyledPageWrapper>
        <div className="main-area">
          <StyledPageHeaderWrapper>
            <StyledPageHeader>1:1 Sessions</StyledPageHeader>
          </StyledPageHeaderWrapper>
          <Tabs defaultActiveKey="1" onTabClick={(key) => handleTabClick(key)}>
            <Tabs.TabPane tab="Upcoming sessions" key="1">
              <ErrorBoundary
                FallbackComponent={({error, resetErrorBoundary}) => (
                  <div>
                    <Alert
                      message="Sorry, something went wrong."
                      showIcon
                      description={error.message}
                      type="error"
                      action={
                        <Button
                          onClick={() => {
                            resetErrorBoundary();
                          }}
                          size="small"
                          danger
                        >
                          Reset
                        </Button>
                      }
                    />
                  </div>
                )}
              >
                <UpcomingCallsComponent
                  handleNewServiceBtnClick={handleNewServiceBtnClick}
                />
              </ErrorBoundary>
            </Tabs.TabPane>
            <Tabs.TabPane tab={"Past sessions"} key="2">
              <ErrorBoundary
                FallbackComponent={({error, resetErrorBoundary}) => (
                  <div>
                    <Alert
                      message="Sorry, something went wrong."
                      showIcon
                      description={error.message}
                      type="error"
                      action={
                        <Button
                          onClick={() => {
                            resetErrorBoundary();
                          }}
                          size="small"
                          danger
                        >
                          Reset
                        </Button>
                      }
                    />
                  </div>
                )}
              >
                <StyledUpcomingCallsWrapper>
                  <PastCallsComponent />
                </StyledUpcomingCallsWrapper>
              </ErrorBoundary>
            </Tabs.TabPane>
          </Tabs>
        </div>
        <div className="widget-area">
          <Space direction="vertical" size={32} style={{display: "flex"}}>
            <NewAvailabilityWidget />
            <TourWidget
              buttons={[
                <Button
                  href="https://www.loom.com/share/62d5824c84d24ed7bb1c596c7c8a34d6?sid=bd23eb7c-e3b2-4d3b-8a56-e3ab5b583f2c"
                  block
                  icon={<VideoCameraOutlined style={{fontSize: "1.6rem"}} />}
                  size="small"
                  target="_blank"
                >
                  <span>Watch demo video</span>
                </Button>,
              ]}
              textInfo="Watch a video guide on how to start hosting 1:1 sessions with your audience and clients."
            />
            <CanvaTemplateWidget url="https://www.canva.com/design/DAGOSXnkoPE/5Fg__pLqNu6jl-cliuexgQ/view?utm_content=DAGOSXnkoPE&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview" />
          </Space>
        </div>
        <CallCategoryModal
          okFunc={handleOk}
          cancelFunc={handleCancel}
          visibleState={openCallCategoryModal}
        />
      </StyledPageWrapper>
    </DashboardWrapper>
  );
};

export {CallsPage};
